import { Injectable } from '@angular/core';
import {
    Resolve,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { ApiService } from '../../core/upgraded-providers';

import { ResourceOrdersDataSource } from './resource-orders.data-source';

@Injectable()
export class ResourceOrdersResolver implements Resolve<any> {

    constructor(
        private _apiService: ApiService
    ) {
    }

    resolve(
        route: ActivatedRouteSnapshot
    ): Promise<any> {
        const { shard, resourceType } = route.params;

        const dataSource = new ResourceOrdersDataSource(this._apiService);
        return dataSource.getData({ shard, resourceType });
    }
}
